var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from "react";
import { Grid, Select, Table } from 'semantic-ui-react';
import { CustomPriceRow } from "../../admin/CustomPriceRow";
import FieldWithErrorDisplay from "../../FieldWithErrorDisplay";
import { LiquidVolume } from "../automated-pro/RnaCatalog";
import { priceColumn } from "../rna-fish/EditKitForm";
import { Help } from "../../Help";
import { ComponentPriceDisplay } from "../rna-fish/ProbeSetForm";
var BufferForm = /** @class */ (function (_super) {
    __extends(BufferForm, _super);
    function BufferForm(props) {
        var _this = _super.call(this, props) || this;
        _this.buffersHelp = React.createElement(React.Fragment, null,
            React.createElement(Help, null,
                "For the following sample types with representative reaction volumes, 20 experiments require approximately:",
                React.createElement("p", null),
                React.createElement(Table, { celled: true, striped: true },
                    React.createElement(Table.Header, null,
                        React.createElement(Table.Row, null,
                            React.createElement(Table.HeaderCell, null, "Sample type"),
                            React.createElement(Table.HeaderCell, null, "Reaction volume (\u00B5L)"),
                            React.createElement(Table.HeaderCell, null, "HCR\u2122 HiFi Antibody Buffer (mL)"),
                            React.createElement(Table.HeaderCell, null, "HCR\u2122 HiFi Antibody Wash Buffer (mL)"),
                            React.createElement(Table.HeaderCell, null, "HCR\u2122 Gold Amplifier Buffer (mL)"),
                            React.createElement(Table.HeaderCell, null, "HCR\u2122 Gold Amplifier Wash Buffer (mL)"))),
                    React.createElement(Table.Body, null,
                        React.createElement(Table.Row, null,
                            React.createElement(Table.Cell, null, "Sample on a slide (e.g., tissue section or adherent cells)"),
                            React.createElement(Table.Cell, null, "100"),
                            React.createElement(Table.Cell, null, "6"),
                            React.createElement(Table.Cell, null, "8"),
                            React.createElement(Table.Cell, null, "6"),
                            React.createElement(Table.Cell, null, "500")),
                        React.createElement(Table.Row, null,
                            React.createElement(Table.Cell, null, "Sample in solution (e.g., whole-mount embryo)"),
                            React.createElement(Table.Cell, null, "200"),
                            React.createElement(Table.Cell, null, "8"),
                            React.createElement(Table.Cell, null, "20"),
                            React.createElement(Table.Cell, null, "8"),
                            React.createElement(Table.Cell, null, "40")))),
                React.createElement("p", null),
                "Note: HCR\u2122 Gold Amplifier Wash Buffer is provided at 4x; dilute to 1x using UltraPure H\u2082O prior to use. Hence, purchasing 50 mL of HCR\u2122 Gold Amplifier Wash Buffer (provided at 4x) yields 200 mL of 1x HCR\u2122 Gold Amplifier Wash Buffer (sufficient for approximately 100 experiments for a sample in solution using the table above)."));
        _this.volumeOptions = function (b) {
            return b.volumeMls.map(function (v) {
                return {
                    text: v.valueMl > 0 ? v.valueWithUnit : 'None',
                    value: v.valueMl
                };
            });
        };
        _this.onAntibodyChange = function (_, data) {
            var scales = _this.props.catalog.antibody.volumeMls;
            _this.onVolumeChange({
                volumeMls: scales,
                defaultVolumeMl: scales[0]
            }, data, 'antibody');
        };
        _this.onAntibodyWashChange = function (_, data) {
            var scales = _this.props.catalog.antibodyWash.volumeMls;
            _this.onVolumeChange({
                volumeMls: scales,
                defaultVolumeMl: scales[0]
            }, data, 'antibodyWash');
        };
        _this.onAmplificationChange = function (_, data) {
            var scales = _this.props.catalog.amplification.volumeMls;
            _this.onVolumeChange({
                volumeMls: scales,
                defaultVolumeMl: scales[0]
            }, data, 'amplification');
        };
        _this.onGoldAmpWashChange = function (_, data) {
            var scales = _this.props.catalog.goldAmpWash.volumeMls;
            _this.onVolumeChange({
                volumeMls: scales,
                defaultVolumeMl: scales[0]
            }, data, 'goldAmpWash');
        };
        _this.onVolumeChange = function (b, data, field) {
            var val = b.volumeMls.find(function (v) { return v.valueMl === data.value; });
            var newScale = val;
            if (newScale === undefined) {
                if (!_this.props.enableCustomScale) {
                    throw new RangeError("Could not find volume " + data.value);
                }
                if (typeof data.value !== 'string') {
                    throw new Error("Invalid scale " + data.value);
                }
                var num = parseInt(data.value, 10);
                if (num === undefined || isNaN(num)) {
                    throw new Error("Invalid scale " + val);
                }
                newScale = new LiquidVolume(num);
            }
            var update = {};
            update[field] = newScale;
            _this.props.onBufferChange(update, _this.props.onUserSelection);
        };
        _this.onCustomPriceChange = function (newStateFn, callback) {
            _this.props.onBufferChange(function (oldState) {
                return {
                    customPrice: newStateFn(oldState.customPrice)
                };
            }, callback);
        };
        return _this;
    }
    BufferForm.prototype.render = function () {
        return React.createElement(Grid, { columns: 4, stackable: true },
            React.createElement(React.Fragment, null,
                React.createElement(Grid.Row, null,
                    React.createElement(Grid.Column, null,
                        React.createElement(FieldWithErrorDisplay, { showErrors: this.props.showErrors, errorPath: '/buffersComponent/antibodyBufferMl', errors: this.props.errors, labelContent: React.createElement(React.Fragment, null,
                                "HiFi Antibody Buffer\u00A0",
                                this.buffersHelp), labelFor: 'buffer-probe-antibody' },
                            React.createElement(Select, { name: 'buffer-probe-anitbody', onChange: this.onAntibodyChange, allowAdditions: this.props.enableCustomScale, search: this.props.enableCustomScale, options: this.volumeOptions(this.props.catalog.antibody), value: this.props.bufferState.antibody.valueMl }))),
                    React.createElement(Grid.Column, null,
                        React.createElement(FieldWithErrorDisplay, { showErrors: this.props.showErrors, errorPath: '/buffersComponent/antibodyWashBufferMl', errors: this.props.errors, labelContent: React.createElement(React.Fragment, null,
                                "HiFi Antibody Wash Buffer\u00A0",
                                this.buffersHelp), labelFor: 'buffer-probe-antibody-wash' },
                            React.createElement(Select, { name: 'buffer-probe-anitbody-wash', onChange: this.onAntibodyWashChange, allowAdditions: this.props.enableCustomScale, search: this.props.enableCustomScale, options: this.volumeOptions(this.props.catalog.antibodyWash), value: this.props.bufferState.antibodyWash.valueMl })))),
                React.createElement(Grid.Row, null,
                    React.createElement(Grid.Column, null,
                        React.createElement(FieldWithErrorDisplay, { showErrors: this.props.showErrors, errorPath: '/buffersComponent/amplificationBufferMl', errors: this.props.errors, labelContent: React.createElement(React.Fragment, null,
                                "Gold Amplifier Buffer\u00A0",
                                this.buffersHelp), labelFor: 'buffer-amplification' },
                            React.createElement(Select, { name: 'buffer-amplification', onChange: this.onAmplificationChange, allowAdditions: this.props.enableCustomScale, search: this.props.enableCustomScale, options: this.volumeOptions(this.props.catalog.amplification), value: this.props.bufferState.amplification.valueMl }))),
                    React.createElement(Grid.Column, null,
                        React.createElement(FieldWithErrorDisplay, { showErrors: this.props.showErrors, errors: this.props.errors, errorPath: '/buffersComponent/goldAmpWashBufferMl', labelContent: React.createElement(React.Fragment, null,
                                "Gold Amplifier Wash Buffer\u00A0",
                                this.buffersHelp), labelFor: 'buffer-gold-amp-probeWash' },
                            React.createElement(Select, { name: "buffer-gold-amp-probeWash", onChange: this.onGoldAmpWashChange, allowAdditions: this.props.enableCustomScale, search: this.props.enableCustomScale, options: this.volumeOptions(this.props.catalog.goldAmpWash), value: this.props.bufferState.goldAmpWash.valueMl }))),
                    React.createElement(Grid.Column, { only: "tablet computer" }),
                    priceColumn(React.createElement(ComponentPriceDisplay, { loading: this.props.priceLoading, effectivePriceCents: this.props.effectivePriceCents, listPriceCents: this.props.listPriceCents }), this.props.effectivePriceCents !== this.props.listPriceCents))),
            this.props.enableCustomPrice &&
                React.createElement(CustomPriceRow, { customPrice: this.props.bufferState.customPrice, defaultEffectivePriceCents: this.props.effectivePriceCents, errors: this.props.errors, errorPathPrefix: '/buffersComponent', onPriceChange: this.onCustomPriceChange, onUserInput: this.props.onUserSelection }));
    };
    return BufferForm;
}(React.PureComponent));
export default BufferForm;
//# sourceMappingURL=BufferForm.js.map


//////////////////
// WEBPACK FOOTER
// ../common/build/dist/kit/manual-gold-if/BufferForm.js
// module id = 1147
// module chunks = 0